const onTokenRefresh = (v2Tokens: { access: string; refresh: string }) => {
  console.warn('🟠 TODO: Update tokens to store:', v2Tokens);
  return Promise.resolve();
};

export { onTokenRefresh };
